export function getHubViews(t) {
  return [
    { id: "needs-reply", label: t("reviewHub.needsReply"), icon: "inbox" },
    { id: "critical", label: t("reviewHub.critical"), icon: "warning", danger: true },
    { id: "all", label: t("reviewHub.allReviews"), icon: "reviews" },
  ];
}
